import React, { useState, useEffect, useRef } from "react";
// import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useHistory } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

function BankBranchManagement() {
    const [group, setGroup] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [status, setstatus] = useState(false);
    const [checked2, setChecked2] = useState(true);
    const [visible, setVisible] = useState(false);

    // useEffect(() => {
    //     const getGroup = async () => {
    //         setloading(true);
    //         // const response = await handleGetRequest("zbiz/fin/branchAuth/fetchAllPendingAuthTransactions");
    //         setGroup(response?.data);
    //         setloading(false);
    //     };
    //     getGroup();
    // }, []);

    let history = useHistory();

    const myData = [
        {
            branchId: 1,
            bankName: "Js Bank Limited",
            branchCode: "Shaheen Complex",
            bankCode: 9001,
        },
        {
            branchId: 2,
            bankName: "NIB",
            branchCode: "I.I.Chundrigar",
            bankCode: 9002,
        },
    ];

    const switchTemplate = () => {
        return <InputSwitch checked={checked2} onChange={(e) => setChecked2(e.value)} />;
    };

    const actionTemplate = () => {
        return (
            <div>
                <i className="pi pi-tag" onClick={(e) => history.push("/editbankbranchmanagement")}></i>
                <i className="pi pi-trash" onClick={confirm1}></i>
            </div>
        );
    };

    const confirm1 = () => {
        confirmDialog({
            message: "Are you sure you want to Delete this?",
            icon: "pi pi-trash",
            acceptLabel: "ok",
            rejectLabel: "cancel",
            accept,
            reject,
        });
    };

    const accept = () => {
        console.log("value is accepted");
    };

    const reject = () => {
        console.log("value is rejected");
    };

    const bulkClicked = () => {
        history.push("/addbulkbranch");
    };

    return (
        <>
            <ConfirmDialog visible={visible} style={{ width: "80vw" }} onHide={() => setVisible(false)} message="Are you sure you want to proceed?" icon="pi pi-trash" accept={accept} reject={reject} />

            <div className="Top__Btn">
                <Button disabled={loading} onClick={bulkClicked} label="Add Bulk Br." className="Btn__Dark" />
                <Button disabled={loading} onClick={(e) => history.push("/addbankbranchmanagement")} label="Add Bank" className="Btn__Dark" />
            </div>
            <div className="card p-datatable-sm">
                <DataTable header="Bank Branch List" value={myData} loading={loading} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)} paginator rows={6} emptyMessage="No data found.">
                    <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                    <Column filter field="branchId" header="Branch ID" />
                    <Column filter field="branchCode" header="Branch Code" />
                    <Column filter field="bankCode" header="Bank Code" />
                    <Column body={switchTemplate} header="Active" />
                    <Column body={switchTemplate} header="Approve" />
                    <Column body={actionTemplate} header="Action" />
                </DataTable>
            </div>
            <div className="Down__Btn">
                <Button label="Delete" onClick={confirm1} className="Btn__Transparent" />
                <Button disabled={loading} onClick={(e) => history.push("/approvebankbranchmanagement")} label="Approve" className="Btn__Dark" />
            </div>
        </>
    );
}

export default BankBranchManagement;
